import { Recipe } from '@library/menu-service'

import { useCollectionRecipeSets } from 'hooks/menu-collections'
import { useRecipes } from 'hooks/menu-recipes/useRecipes'
import { CollectionId } from 'routes/Menu/domains/collections'

export const useRecipesFromAllRecipesCollection = (): Recipe[] => {
  const recipeSetsInCollection = useCollectionRecipeSets(CollectionId.AllRecipes) || []
  const recipeIdsInCollection = recipeSetsInCollection.map((recipeSet) => recipeSet.baseRecipeId)
  const recipesInCollection = useRecipes(recipeIdsInCollection)

  // recipesInCollection is in recommended order
  return recipesInCollection
    .filter((recipe) => {
      const recipeSlug = recipe?.foodBrand?.slug
      const isEveryDayFavourites = recipeSlug === 'everyday-favourites'
      const isOvenReady = recipe?.name?.includes("Charlie Bigham's")

      return recipeSlug && !isOvenReady && !isEveryDayFavourites && recipe
    })
    .filter((recipe): recipe is Recipe => Boolean(recipe))
}
